<template>
  <div>
    <div style="display: flex; align-items: flex-start;">
      <commission-list/>
    </div>
  </div>
</template>

<script>
import CommissionList from '../../components/reports/commission/List';

export default {
  components: {
    CommissionList,
  },
  data() {
    return {

    }
  },
  computed: {

  },
  async mounted() {
    this.loading = true;
    this.loading = false;
  },
  methods: {

  }
};
</script>

<style lang="scss">
  .filter-container {
    padding: 20px;
    margin: -20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #EBEEF5;
  }
</style>
